import {Route, Routes} from "react-router-dom";
import MainLayout from "./layouts/mainLayout";
import Home from "./pages/home";
import AboutUs from "./pages/home/aboutUs";
import ContactUs from "./pages/home/contactUs";
import NotFound from "./pages/home/404";
import Logout from "./pages/logout";
import EmptyLayout from "./layouts/emptyLayout";
import Share from "./pages/home/share";
import Dashboard from "./pages/dashboard";
import DashboardLayout from "./layouts/dashboardLayout";
import DashboardLogin from "./pages/dashboard/login";
import Settings from "./pages/dashboard/settings";
import MyShares from "./pages/dashboard/myShares";
import MyContacts from "./pages/dashboard/myContacts";
import {default as DashboardRequestShare} from "./pages/dashboard/requestShare";
import {default as DashboardPlans} from "./pages/dashboard/plans";
import RequestFileView from "./pages/home/share/request";
import SeeShare from "./pages/dashboard/seeShare";
import ConnectedDevices from "./pages/dashboard/connectedDevices";
import RequestShare from "./pages/home/requestShare";
import Plans from "./pages/home/plans";
import Verify from "./pages/verify";
import Transactions from "./pages/dashboard/transactions";
import MyReceives from "./pages/dashboard/myReceives";
import Download from "./pages/home/download";
import Landing from "./pages/home/landing";

function App() {

    if ("serviceWorker" in navigator) {
        window.addEventListener("load", function () {
            navigator.serviceWorker
                .register("/serviceWorker.js")
                .catch(err => console.log("service worker not registered", err))
        })
    }

    return (
        <Routes>
            <Route path="/" exact element={<MainLayout><Home/></MainLayout>}/>
            <Route path="/about-us" element={<MainLayout><AboutUs/></MainLayout>}/>
            <Route path="/landing" element={<MainLayout><Landing/></MainLayout>}/>
            <Route path="/contact-us" element={<MainLayout><ContactUs/></MainLayout>}/>
            <Route path="/request-share" element={<MainLayout><RequestShare/></MainLayout>}/>
            <Route path="/plans" element={<MainLayout><Plans/></MainLayout>}/>
            <Route path="/share/:shareFolderId" element={<MainLayout><Share/></MainLayout>}/>
            <Route path="/share/request/:linkAddress" element={<MainLayout><RequestFileView/></MainLayout>}/>
            <Route path="/download" element={<MainLayout><Download/></MainLayout>}/>
            <Route path="/drive" element={<DashboardLayout><Dashboard/></DashboardLayout>}/>
            <Route path="/drive/:folderId" element={<DashboardLayout><Dashboard/></DashboardLayout>}/>
            <Route path="/drive/my-shares" element={<DashboardLayout><MyShares/></DashboardLayout>}/>
            <Route path="/drive/my-contacts" element={<DashboardLayout><MyContacts/></DashboardLayout>}/>
            <Route path="/drive/my-receives" element={<DashboardLayout><MyReceives/></DashboardLayout>}/>
            <Route path="/drive/request-share" element={<DashboardLayout><DashboardRequestShare/></DashboardLayout>}/>
            <Route path="/drive/see-share" element={<DashboardLayout><SeeShare/></DashboardLayout>}/>
            <Route path="/drive/plans" element={<DashboardLayout><DashboardPlans/></DashboardLayout>}/>
            <Route path="/drive/connected-devices" element={<DashboardLayout><ConnectedDevices/></DashboardLayout>}/>
            <Route path="/drive/transactions" element={<DashboardLayout><Transactions/></DashboardLayout>}/>
            <Route path="/drive/login" element={<EmptyLayout><DashboardLogin/></EmptyLayout>}/>
            <Route path="/drive/settings" element={<DashboardLayout><Settings/></DashboardLayout>}/>
            <Route path="/logout" element={<EmptyLayout><Logout/></EmptyLayout>}/>
            <Route path="/verify" element={<EmptyLayout><Verify/></EmptyLayout>}/>
            <Route path="*" element={<EmptyLayout><NotFound/></EmptyLayout>}/>
        </Routes>
    )
}

export default App;
